/**
 * @generated SignedSource<<2bc5de65a3ba2b0ec891010073ba8f5b>>
 * @relayHash 77a6818739167db80cdae8973d4ca8d8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 856547b1ab9dd731c0d2f2a52aaa7f1a1c307240fa8cae50a118b16316a68cb5

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { main_getIssueTransitionByIdRootQuery } from './main_getIssueTransitionByIdRootQuery.graphql';

import isFCFAccessNarrowingEnabled_provider from '@atlassian/jira-relay-provider/src/fcf-its-with-access-narrowing.relayprovider';
import includeEgressOverridesForge_provider from '@atlassian/jira-relay-provider/src/forge-query-include-egress-overrides.relayprovider';
import includeUserAccess_provider from '@atlassian/jira-relay-provider/src/forge-query-include-user-access.relayprovider';
import isNikeChinMigrateMultiSelectEditViewDeprecatedEnabled_provider from '@atlassian/jira-relay-provider/src/nike-chin-migrate-multi-select-edit-view-deprecated.relayprovider';

const node: PreloadableConcreteRequest<main_getIssueTransitionByIdRootQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "856547b1ab9dd731c0d2f2a52aaa7f1a1c307240fa8cae50a118b16316a68cb5",
    "metadata": {},
    "name": "main_getIssueTransitionByIdRootQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcforgequeryincludeuseraccessrelayprovider": includeUserAccess_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcfcfitswithaccessnarrowingrelayprovider": isFCFAccessNarrowingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcforgequeryincludeegressoverridesrelayprovider": includeEgressOverridesForge_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinmigratemultiselecteditviewdeprecatedrelayprovider": isNikeChinMigrateMultiSelectEditViewDeprecatedEnabled_provider
    }
  }
};

export default node;
